import api, { WisdomCashierTemplate } from "api";
import { AppAction, AppButton, AppGridBar, AppGridLayout, AppGridTabs, AppRow, AppSearchItem, AppTable, AppTableSearch } from 'qcc';
import React from 'react';
import TemplateEditForm from './TemplateEditForm';

const printStyle = { "sb": "A4竖排打印", "A4横版打印": "hb" };
const printCopies = { "yy": "一式一份", "yl": "一式两份", "ys": "一式三份" };
const printCategary = { "dm": "单面打印", "sm": "双面打印" };
export default class extends React.Component {
  state = {}
  // 新增模板
  add = async () => {
    let projectId = 0;
    if (this.refTableSearch.current)
      projectId = (this.refTableSearch.current.state.data.projectId) || 0;
    if (projectId === 0) return;
    let formData = { type: 0, templateName: '', printCount: '', fundTypeName: '', isEnabled: 0, projectId, projectName: "" } as WisdomCashierTemplate;
    let title = '新增模板';
    let editForm = <TemplateEditForm mode={1} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, width: 600, height: 460 });
  }
  // 编辑
  edit = async (data: any) => {
    let formData = await api.wisdomcashiertemplate.getOne({ id: data.id })
    console.log("formData", formData)
    let title = '编辑模板';
    let editForm = <TemplateEditForm mode={2} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, width: 600, height: 460 });
  }

  // 启用
  enable = async (data: any) => {
    let id = data.id;
    if (!data.sealcode || data.sealcode === '') {
      AppAction.warnMsg("请关联模板！")
      return false
    }
    if (await AppAction.confirm("您确定要启用该模板吗？")) {
      await api.wisdomcashiertemplate.enable({ id });
      AppAction.successMsg("操作成功！")
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      return true;
    }
    return false;
  }

  // 禁用
  disable = async (data: any) => {
    let id = data.id;
    if (await AppAction.confirm("您确定要禁用该模板吗？")) {
      await api.wisdomcashiertemplate.disable({ id });
      AppAction.successMsg("操作成功！")
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      return true;
    }
    return false;
  }

  // 下载模板
  openFile = (data: any) => {
    if (data.templat_url) {
      window.location.href = `/api/public/download?filePath=${data.templat_url}&fileName=单据模板.docx`
    } else {
      AppAction.warnMsg("当前收据未上传模板");
      return
    }
  }

  // 删除
  delete = async (receiptTemplate: any) => {
    receiptTemplate as WisdomCashierTemplate;
    console.log("receiptTemplate", receiptTemplate);
    if (receiptTemplate.is_enabled === 1) {
      AppAction.warnMsg("该模板状态已启用不可删除");
      return;
    }
    if (await AppAction.deleteConfirm('您确定要删除该模板吗？')) {
      let res = await api.wisdomcashiertemplate.delete(receiptTemplate);
      AppAction.successMsg('删除成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }
  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }
  refGrid = React.createRef<AppGridLayout>();
  refTableSearch = React.createRef<AppTableSearch>();
  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.SearchArea>
          <AppTableSearch ref={this.refTableSearch}>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Left>
              <AppGridTabs tabs={['单据模板列表']} />
            </AppGridBar.Left>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='新增' actionCode="66101101" type='primary' action={this.add} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging
            sqlId='sql.wisdomCashier.templateGird'
            onBeforeApi={(data: any) => { return data.projectId !== undefined }}
          >
            <AppTable.ColIndex />
            <AppTable.Col title='模板名称' field='template_name' />
            <AppTable.Col title='sap模板Id' field='erp_temp_id' width={250} />
            <AppTable.Col title='打印份数' field='print_count' align="center" width={150}
              render={
                (template: any) => {
                  return (printCopies[template.print_count])
                }} />
            <AppTable.Col title='单面/双面打印' field='print_type' align="center" width={150}
              render={
                (template: any) => {
                  return (printCategary[template.print_type])
                }} />
            <AppTable.Col title='是否启用' field='is_enabled' align="center" width={100}
              render={
                (template: any) => {
                  return (<span>{template.is_enabled === 0 ? "否" : "是"}</span>)
                }
              } />
            <AppTable.Col title='印章编号' field='sealcode' width={150} />
            <AppTable.ColAction width={200} render={(data: any, dataIndex: number) => {
              let { is_enabled, sealcode } = data
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                {is_enabled === 0 ? <AppButton type='link' label='编辑' actionCode="66101102" action={() => this.edit(data)} /> : null}
                {is_enabled === 0 ? <AppButton type='link' label='启用' actionCode="66101111" action={() => this.enable(data)} /> : null}
                {is_enabled === 1 ? <AppButton type='link' label='禁用' actionCode="66101111" action={() => this.disable(data)} /> : null}
                <AppButton type='link' label='下载模板' actionCode="66101102" action={() => this.openFile(data)} />
                <AppButton type='link' label='删除' actionCode="66101103" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/template/TemplateGird.tsx